import Vue from 'vue'
import axios from 'axios'
import {
    Message,
    Loading
} from 'element-ui';

import router from "../router";
import store from "../vuex/store";
let AUTH_TOKEN = (() => {
    return store.state.logintoken || '';
})();
const paramsHeader = {
    timeout: 60000,
    baseURL: envConfig.NODE_API,
    headers: {},
    // responseType: "json",
    withCredentials: true, // 是否允许带cookie这些
};
let dataHeader = {};
const instance = axios.create(Object.assign(paramsHeader, dataHeader))
// 请求超时重新请求次数，请求间隙
instance.defaults.retry = 2
instance.defaults.retryDelay = 5000
instance.interceptors.request.use(
    config => {
        //动态token
        let url = config.url;
        config.headers.common["Authorization"] = store.state.logintoken;
        if (url.indexOf('file/chunkUpload') == -1) {
            store.state.loading = true
        }

        return config;
    },
    error => {
        return Promise.reject(error);
    }
);
instance.interceptors.response.use(
    response => {
        store.state.loading = false;
        if (response.data.code == 200 || response.headers['content-type'] == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8") {
            return response;
        } else {
            Message.error(response.data.desc);
            return Promise.reject(response)
        }
    },
    error => {
        store.state.loading = false
        if (error.response.status == 401) {
            Message.error(error.response.msg || '请重新登陆');
            store.commit('logout', 'false');
            router.push({ path: '/login' })
            return
        }
        var config = error.config;
        // config.__retryCount  当前请求次数
        //config.retry  设置请求次数
        // config.retryDelay  设置请求间隙
        if (!config || !config.retry) {
            Message.error(error.response.data.message || '服务器超时，请稍后再试！')
            return Promise.reject(error)
        }
        config.__retryCount = config.__retryCount || 0
        if (config.__retryCount >= config.retry) {
            Message.error(error.response.data.message || '服务器超时，请稍后再试！')
            return Promise.reject(error)
        }
        config.__retryCount += 1;
        let backoff = new Promise((resolve) => {
            setTimeout(() => {
                resolve()
            }, config.retryDelay || 1)
        })
        return backoff.then(() => {
            return instance(config)
        })
    }
)
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get (url, params = {}, header) {
    return new Promise((resolve, reject) => {
        instance.get(url, {
            params: params,
            headers: { ...header },
            responseType: (header && header.responseType) ? header.responseType : null,
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                console.log(err);
                reject(err.response)
            })
    })
}
/**
 * 封装post请求
 * @param url
 * @param data
 * @param header
 * @returns {Promise}
 */
export function post (url, data, header = {}) {
    // dataHeader = header;
    return new Promise((resolve, reject) => {
        instance.post(url, data, {
            headers: { ...header },
            responseType: (header && header.responseType) ? header.responseType : null,
        }
        )
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err.response)
            })
    })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function patch (url, data = {}) {
    return new Promise((resolve, reject) => {
        instance.patch(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err.response)
            })
    })
}
/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put (url, data = {}) {
    return new Promise((resolve, reject) => {
        instance.put(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err.response)
            })
    })
}
/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function deleteApi (url, data = {}) {
    return new Promise((resolve, reject) => {
        instance.delete(url, { data })
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err.response)
            })
    })
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js